import React from 'react';
import { Gallery } from 'react-gesture-gallery';

import Stepper from './components/Stepper';
import { PictureContainer, Image } from './styles';

interface Props {
  images: string[];
  fit: 'cover' | 'contain';
  height?: number;
  enableKeyboard?: boolean;
}

const Pictures = ({ images, fit, height, enableKeyboard = true }: Props) => {
  const [index, setIndex] = React.useState(0);

  return (
    <PictureContainer height={height}>
      <Stepper count={images.length} index={index} />
      <Gallery
        index={index}
        enableIndicators={false}
        enableControls
        enableKeyboard={enableKeyboard}
        onRequestChange={setIndex}
      >
        {images.map((image) => (
          <Image objectFit={fit} key={image} src={image} />
        ))}
      </Gallery>
    </PictureContainer>
  );
};

export default Pictures;
